<p-button
  text
  rounded
  severity="secondary"
  size="small"
  [label]="getLangLabel(activeLang())"
  (click)="togglePopover($event)"
></p-button>

<p-popover #popover>
  <div class="flex flex-col">
    @for (lang of availableLangs; track lang) {
      <p-button
        text
        size="small"
        class="justify-start w-full text-start"
        [severity]="lang === activeLang() ? 'primary' : 'secondary'"
        [label]="lang | transloco"
        (click)="setLang(lang)"
      ></p-button>
    }
  </div>
</p-popover>
